module.exports = __webpack_public_path__ + "static/media/JINGLE_RAFFLE_FAST.4134762a.mp3";